/**
 * Event-related TypeScript type definitions.
 */

export interface Event {
    id: string;
    name: string;
    account_id: string;
    start_at: string | null;
    ends_at: string | null;
    is_public: boolean;
    join_code: string | null;
    created_at: string;
    updated_at: string;
}

export interface EventCreate {
    name: string;
    start_at?: string | null;
    ends_at?: string | null;
    is_public?: boolean;
    join_code?: string | null;
}

export interface EventUpdate {
    name?: string;
    start_at?: string | null;
    ends_at?: string | null;
    is_public?: boolean;
    join_code?: string | null;
}

export interface EventListResponse {
    events: Event[];
    total: number;
}

export interface EventsState {
    events: Event[];
    currentEvent: Event | null;
    total: number;
    isLoading: boolean;
    error: string | null;
}

// LocalStorage key for persisting last active event
export const LAST_EVENT_ID_KEY = 'lastEventId';

/**
 * Public-lobby join code constraints. Server-side mirror of the same constraints
 * lives in `ft-backend/app/schemas/event.py`. Keep these in sync.
 */
export const JOIN_CODE_MIN = 4;
export const JOIN_CODE_MAX = 16;
export const JOIN_CODE_PATTERN = /^[A-Za-z0-9]{4,16}$/;
